import React from 'react';

import { ISettings } from '../../../lib/settings/types';

const { Provider: SettingsProvider, Consumer: SettingsConsumer } =
  React.createContext<ISettings>(null);

export { SettingsProvider, SettingsConsumer };
